<template>
    <div class="movie-view" :style="{ paddingTop: height169 + 84 + 'px' }">
        <app-view @open="onOpen" @restore="onRestore" @close="onClose">
            <div class="fixedTop">
                <div class="video" v-if="share" :style="{ height: height169 + 'px' }"></div>
                <div class="tip" v-if="!ready" :style="{ height: height169 + 'px', textAlign: 'center' }">
                    该视频由福音影视网提供播放
                    <br />WWW.FUYINTV.COM
                </div>
                <div class="video-container" :style="{ height: height169 + 'px' }" v-show="ready && !share">
                    <movie-video ref="video" :movie="movie" @end="onPlayEnd"></movie-video>
                </div>
                <div class="download" :class="{ off: !download }">
                    <a href="http://www.fytvapp.com">
                        <i class="icon icon-loading"></i>
                        <span>点击下载福音TV APP功能更强大</span>
                        <i class="icon icon-download"></i>
                    </a>
                    <a href="javascript:;" class="icon icon-right" @click="onCloseDownload"></a>
                </div>
                <toolbar :favourite="favourite" @download="onOpenDownload" @intro="onIntro" @list="onList" @favourite="onFavourite" @note="onNote"></toolbar>
                <div class="current">当前播放：{{ current.title }}</div>
            </div>
            <a href="javascript:;" class="ad" v-if="
                movie.zs &&
                movie.zs.open &&
                movie.zs.target !== 'miniprogram'
            " @click="onGoAd">
                <img :src="movie.zs.image" />
            </a>
            <div v-if="intro" class="intro">
                <div v-html="movie.content"></div>
            </div>
            <play-list v-else :player="player" @video="onClickPlayVideo" @audio="onPlayAudio" @download-audio="onDownloadAudio" @pdf="onDownloadPdf"></play-list>
            <app-confirm ref="confirm"></app-confirm>
        </app-view>
    </div>
</template>
<script>
import AppConfirm from '../components/AppConfirm.vue'
import AppView from '../components/AppView.vue'
import MovieVideo from './MovieVideo.vue'
import PlayList from './PlayList.vue'
import Toolbar from './Toolbar.vue'

export default {
    components: { AppView, AppConfirm, MovieVideo, Toolbar, PlayList },
    data() {
        return {
            current: {},
            intro: false,
            favourite: false,
            ready: false,
            player: {
                index: -1,
                video: false,
                audio: false
            },
            download: true
        }
    },
    computed: {
        share() {
            return this.$service.common.share
        },
        movid() {
            return this.$route.params.movid
        },
        urlid() {
            return parseInt(this.$route.query.urlid)
        },
        isAudio() {
            return this.$route.query.audio === '1'
        },
        movie() {
            return this.$service.movie.movie
        },
        height169() {
            return window.innerWidth * 9 / 16
        }
    },
    methods: {
        onGoAd() {
            this.$service.other.goItem(this.movie.zs, this.$router)
        },
        async getResource(item) {
            if (item.resource) {
                return item.resource
            } else {
                item.resource = await this.$service.movie.getUrl(item.urlid, this.movid)
                return item.resource
            }
        },
        async onClickPlayVideo({ index, auto }) {
            // if (await this.$refs.confirm.show('下载福音TV APP播放更流畅', { ok: '现在下载', cancel: '暂时不用' })) {
            //     window.location = 'http://www.fytvapp.com'
            //     return
            // }
            let item = this.movie.urls[index]
            if (item.mp4) {
                this.onPlayVideo(index, true)
            } else {
                if (auto) {
                    this.onPlayAudio(index, true)
                } else {
                    this.$toast('暂时没有这个资源')
                }
            }
        },
        async onPlayVideo(index, auto = true) {
            let item = this.movie.urls[index]
            if (this.player.index === index && this.player.video) {
                this.$service.wechat.callShare({
                    title: this.movie.title + item.sort_title,
                    link: `${window.location.origin}/#movie/${this.movid}?urlid=${item.urlid}`,
                    imgUrl: this.movie.pic
                })
                return
            }
            if (item.mp4) {
                let resource = await this.getResource(item)
                this.player = {
                    index,
                    video: true,
                    audio: false
                }
                this.current = item
                this.$refs.video.play(resource, auto, false)
                this.$service.wechat.callShare({
                    title: this.movie.title + item.sort_title,
                    link: `${window.location.origin}/#movie/${this.movid}?urlid=${item.urlid}`,
                    imgUrl: this.movie.pic
                })
            } else {
                this.onPlayAudio(index, auto)
            }
        },
        async onPlayAudio(index, auto = true) {
            let item = this.movie.urls[index]
            if (this.player.index === index && this.player.audio) {
                this.$service.wechat.callShare({
                    title: this.movie.title + item.sort_title,
                    link: `${window.location.origin}/#movie/${this.movid}?urlid=${item.urlid}`,
                    imgUrl: this.movie.pic
                })
                return
            }
            let resource = await this.getResource(item)
            this.player = {
                index,
                video: false,
                audio: true
            }
            this.current = item
            this.$refs.video.play(resource, auto, true)
            this.$service.wechat.callShare({
                title: this.movie.title + item.sort_title,
                link: `${window.location.origin}/#movie/${this.movid}?urlid=${item.urlid}`,
                imgUrl: this.movie.pic
            })
        },
        async onDownloadAudio(index) {
            let item = this.movie.urls[index]
            let resource = await this.getResource(item)
            window.location.href = resource.url_6
        },
        onDownloadPdf(index) {
            let item = this.movie.urls[index]
            if (item.doc) {
                window.location.href = `https://www.ifuyin.com/index.php/content/downfile/urlid/${item.urlid}/type/4/`
            } else {
                this.$toast('暂时没有这个资源')
            }
        },
        onIntro() {
            this.intro = true
        },
        onList() {
            this.intro = false
        },
        async onFavourite() {
            if (this.favourite) {
                await this.$service.user.removeFavourite(this.favourite.id)
                this.favourite = false
            } else {
                this.favourite = await this.$service.user.addFavourite(this.movie)
            }
        },
        onNote() {
            let item = this.movie.urls[this.player.index]
            this.$router.push({
                name: 'note-editor',
                params: {
                    movid: this.movid,
                    urlid: item.urlid
                },
                query: {
                    m: this.movie.title,
                    t: item.title
                }
            })
        },
        async onOpen() {
            this.favourite = await this.$service.user.isFavourite(this.movid)
            await this.$service.movie.loadMovie(this.movid)
            this.$service.common.title = this.movie.title
            let index = 0
            if (this.urlid > 0) {
                index = this.movie.urls.findIndex(item => item.urlid === this.urlid)
            }
            let item = this.movie.urls[index]
            this.url = 'fuyintv://tv/movie?movid=' + this.movid + '&urlid=' + item.urlid
            window.location.href = this.url

            document.body.scrollTop = index * 44

            if (this.isAudio) {
                this.onPlayAudio(index, false)
            } else {
                this.onPlayVideo(index, false)
            }
            this.download = true
            setTimeout(() => {
                this.ready = true
            }, 3000)
            // if (await this.$refs.confirm.show('下载福音TV APP播放更流畅', { ok: '现在下载', cancel: '暂时不用' })) {
            //     window.location = 'http://www.fytvapp.com'
            //     return
            // }
            this.$service.user.closeSubscribe()
        },
        async onRestore() {
            if (this.movie.movid) {
                this.favourite = await this.$service.user.isFavourite(this.movid)
                this.$service.common.title = this.movie.title
            } else {
                this.onOpen()
            }
            this.download = true
            setTimeout(() => {
                this.download = false
            }, 3000)
        },
        onClose() {
            let item = this.movie.urls[this.player.index]
            let time = this.$refs.video.time
            this.$service.movie.clearMovie()
            this.intro = false
            this.favourite = false
            this.ready = false
            this.player = {
                index: -1,
                video: false,
                audio: false
            }
        },
        async onPlayEnd() {
            // if (await this.$refs.confirm.show('下载福音TV APP播放更流畅', { ok: '现在下载', cancel: '暂时不用' })) {
            //     window.location = 'http://www.fytvapp.com'
            //     return
            // }
            if (await this.$service.user.checkUserState(this, false, true)) {
                this.onPlayEnd3()
            }
        },
        async onPlayEnd3() {
            if (this.urlid > 0) {
            } else {
                if (this.player.index < this.movie.urls.length - 1) {
                    this.onPlayVideo(this.player.index + 1, true)
                }
            }
        },
        async onPlayEnd2() {
            let tip = '暂时不用'
            if (this.urlid > 0) {
            } else {
                if (this.player.index < this.movie.urls.length - 1) {
                    tip = '继续播放'
                }
            }
            if (await this.$refs.confirm.show('下载福音app 体验更多功能', { ok: '点击下载', cancel: tip })) {
                window.location = 'http://www.fytvapp.com'
            } else {
                if (this.urlid > 0) {
                } else {
                    if (this.player.index < this.movie.urls.length - 1) {
                        this.onPlayVideo(this.player.index + 1, true)
                    }
                }
            }
        },
        onCloseDownload() {
            this.download = false
        },
        onOpenDownload() {
            this.download = true
        }
    }
}
</script>
<style scoped lang='scss'>
.movie-view {
    background-color: $color-white;

    .video {
        background-color: $color-black;
    }

    .tip {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: $color-black;
        color: $color-white;
        font-size: 18px;
    }

    .current {
        height: 40px;
        line-height: 40px;
        padding: 0 10px;
        background-color: white;
        border-bottom: 1px solid #e2e2e2;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .download {
        position: absolute;
        left: 0;
        bottom: 40px;
        width: 100%;
        line-height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        border-bottom: $style-border;
        background-color: #f8f8f8;
        color: $color-red;
        transition: all 1s;

        &.off {
            transform: translate(100%, 0);
        }

        >a {
            &:first-child {
                display: flex;
                align-items: center;
                justify-content: center;
                flex: 1;

                .icon-loading {
                    font-size: 20px;
                    animation: loading-rotate 2s infinite linear;
                }

                @keyframes loading-rotate {
                    100% {
                        transform: rotate(360deg);
                    }
                }

                >span {
                    margin: 0 4px;
                }
            }

            &:last-child {
                width: 44px;
                font-size: 20px;
                border-left: $style-border;
            }
        }
    }

    .intro {
        padding: $app-padding;
    }
}

.ad {
    display: block;
    margin: 8px 0;

    img {
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// index.vue?5167d8df